import React from 'react'

const InfoIcon = props => (
  <svg viewBox="0 0 2 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.69687 7.5H0.296875V6.1H1.69687V7.5ZM1.69687 4.7H0.296875V0.5H1.69687V4.7Z"
      fill="currentColor"
    />
  </svg>
)

export default InfoIcon
